import { call, put, takeLatest } from "redux-saga/effects";
import {
  onPostActiveCard,
  onPostActiveCardError,
  onPostActiveCardSuccess,
} from "../Store/Slices/activeCardSlice";
import { callActiveCardPostApi } from "../Context/activeCardApi";

function* PostActiveCard({ payload }) {
  try {
    const postActiveCardResponse = yield call(callActiveCardPostApi, payload);
    if (postActiveCardResponse.responseCode === "200") {
      yield put(
        onPostActiveCardSuccess({
          postData: postActiveCardResponse.response,
          message: postActiveCardResponse.responseMessage,
          status_code: postActiveCardResponse.responseCode,
        })
      );
    } else {
      yield put(
        onPostActiveCardError({
          data: postActiveCardResponse.response,
          message: postActiveCardResponse.responseMessage,
          status_code: postActiveCardResponse.responseCode,
        })
      );
    }
  } catch (error) {
    const message =
      error.response.data.responseMessage || "Something went wrong";
    yield put(onPostActiveCardError({ data: [], message, status_code: 400 }));
  }
}
export default function* activeCardSaga() {
  yield takeLatest(onPostActiveCard.type, PostActiveCard);
}
